<template>
  <div>
    <div id="app" class="wrapper">
      <ux-nav-bar></ux-nav-bar>
      <router-view></router-view>
      <ux-page-footer></ux-page-footer>
    </div>
    <portal-target name="modal"></portal-target>
  </div>
</template>
<script>
import UxPageFooter from "@/components/UxPageFooter";
import UxNavBar from "@/components/UxNavBar";
export default {
  components: { UxPageFooter, UxNavBar }
};
</script>
<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Roboto:300,400,500,700");
@import "./assets/sass/_vars.scss";
@import "./assets/sass/global.scss";
.wrapper {
  min-height: 100vh;
  display: grid;
  grid-template-rows: auto 1fr auto;
}
</style>
